<template>
    <div class="bookConfirmOrder">
        <Head :title="title"></Head>
        <!-- 主题部分 -->
        <div class="content">
            <!-- 收货地址 -->
            <div
                v-if="Address.provinceName !== ''"
                class="content_address"
                @click="increaseAddress"
            >
                <div class="content_address_left">
                    <p class="address">
                        <span
                            >{{ Address.provinceName }} {{ Address.cityName }}
                            {{ Address.districtName }}</span
                        >
                    </p>
                    <h3>{{ Address.detailAddress }}</h3>
                    <h4>{{ Address.consignee }} {{ sectionPhone }}</h4>
                </div>
                <div class="icon">
                    <img src="@/assets/mylogin/arrow-icon.png" alt="" />
                </div>
            </div>
            <!-- 没有设置收货地址显示 -->
            <div v-else class="content_noaddress" @click="increaseAddress">
                <van-cell title="请填写地址信息" icon="location-o" is-link />
            </div>
            <!-- 商品名称 -->
            <div class="commodity_name">
                <div class="title">商品名称</div>
                <div class="contents">
                    <div class="commodity_name_left">
                        <img
                            v-if="!information.pictureUrl"
                            src="@/assets/img/qietu/zz_default.png"
                            alt=""
                        />
                        <img v-else :src="information.pictureUrl" alt="" />
                    </div>
                    <div class="commodity_name_right">
                        <p>{{ information.monographName }}</p>
                        <div class="introduction">
                            <div class="details">{{ information.selectedText }}</div>
                            <div class="number">×{{ information.selectedNum }}</div>
                        </div>
                        <div class="price">¥{{ totalPrice }}</div>
                    </div>
                </div>
            </div>

            <div class="order-remark">
                <van-cell
                    title="订单备注"
                    is-link
                    :value="remark !== '' ? remark : '无备注'"
                    :value-class="remark !== '' ? 'cell-value' : ''"
                    @click="openPopup('remark')"
                />
                <van-cell
                    v-if="Number(totalPrice) > 0"
                    title="发票"
                    is-link
                    :value="
                        userInvoiceInfo.invoiceHeader ? userInvoiceInfo.invoiceHeader : '不开发票'
                    "
                    value-class="cell-value"
                    @click="toInvoice()"
                />
            </div>
            <!-- 支付方式 -->
            <div class="payment" v-if="Number(totalPrice) > 0">
                <div class="title">支付方式</div>
                <van-radio-group v-model="radio" direction="horizontal">
                    <div class="option">
                        <div class="zhifubao">
                            <img src="@/assets/mylogin/zhifubao-logo.png" alt="" />
                            <div class="option_name">支付宝</div>
                        </div>
                        <van-radio name="1" style="margin-top: 18px"></van-radio>
                    </div>
                    <div class="option">
                        <div class="weixin">
                            <img src="@/assets/mylogin/weixinzhifu2@2x.png" alt="" />
                            <div class="option_name">微信支付</div>
                        </div>
                        <van-radio name="2" style="margin-top: 18px"></van-radio>
                    </div>
                </van-radio-group>
            </div>
            <van-action-sheet v-model="remarkPopupShow" title="备注">
                <div class="popup-content">
                    <van-field
                        ref="remark"
                        @focus="handleElemInView"
                        class="popup-input popup-textarea"
                        v-model="remarkPopup"
                        rows="8"
                        type="textarea"
                        maxlength="200"
                        placeholder="请输入备注"
                        show-word-limit
                    />
                    <van-button class="popup-btn" type="default" @click="confirmRemark()"
                        >确定</van-button
                    >
                </div>
            </van-action-sheet>
        </div>
        <!-- 底部按钮 -->
        <div class="submit">
            <div class="money">¥{{ totalPrice }}</div>
            <van-button type="info" class="obt" @click="generate" :disabled="btnDisabled"
                >提交订单</van-button
            >
        </div>

        <!-- 失败弹框 -->
        <van-dialog v-model="hshow" title="交易订单处理失败，请重新发起支付" show-cancel-button>
            <img
                style="width: 35px; height: 35px; margin: 27px auto; display: block"
                src="../../../assets/mylogin/shibai-2@2x.png"
            />
        </van-dialog>
        <!-- 银联失败弹框 -->
        <van-popup v-model="sshow">
            <img
                style="width: 35px; height: 35px; margin: 27px auto; display: block"
                src="../../../assets/mylogin/shibai-2@2x.png"
            />
            <div style="font-size: 14px; font-weight: 400; color: #333333">
                交易订单处理失败，请重新发起支付
            </div>
            <!-- 点击查看订单跳转到订单详情页 -->
            <van-button plain type="info">查看订单</van-button>
        </van-popup>
    </div>
</template>

<script>
import { Dialog } from "vant";
import { Toast } from "vant";
import Head from "@/views/mobileView/My/components/headTabs.vue";
export default {
    name: "bookConfirmOrder",
    computed: {
        totalPrice() {
            return (
                ((this.information.skuPrice * 100 * this.information.selectedNum) / 100).toFixed(
                    2
                ) + ""
            );
        },
        sectionPhone() {
            return this.Address.phone.substring(0, 3) + "****" + this.Address.phone.substring(7);
        },
    },
    data() {
        return {
            title: "确认订单",
            radio: "1",
            information: {
                monographName: "",
                pictureUrl: "",
                selectedNum: "",
                selectedText: "",
                skuPrice: "",
            },
            // 接口数据
            Address: {
                provinceName: "",
                cityName: "",
                districtName: "",
                detailAddress: "",
                consignee: "",
                phone: "",
            },

            confirmList: [],
            // 生成订单的id
            payBatchId: "",
            hshow: false,
            sshow: false,
            btnDisabled: false, // 提交订单时禁用按钮，防止快速点击产生多比订单
            timer: null,
            // 备注参数
            remark: "",
            remarkPopupShow: false,
            remarkPopup: "",
            userInvoiceInfo: {},
        };
    },
    components: {
        Head,
    },
    created() {
        this.userInvoiceInfo = sessionStorage.getItem("userInvoiceInfo")
            ? JSON.parse(sessionStorage.getItem("userInvoiceInfo"))
            : {};
        this.information = JSON.parse(localStorage.getItem("bookDetails"));
        this.confirmList = JSON.parse(localStorage.getItem("bookParameter"));
        if (sessionStorage.getItem("Address")) {
            this.Address = JSON.parse(sessionStorage.getItem("Address"));
        } else {
            this.getByUserLists();
        }
    },

    methods: {
        toInvoice() {
            let query = {
                from: "orderConfirm",
            };
            this.$router.push({ path: "/invoice", query });
        },
        // 生成订单
        async generate() {
            if (this.Address.id) {
                this.btnDisabled = true;
                let obj = {
                    list: this.confirmList,
                    originProject: "information",
                    sysUserAddressId: this.Address.id,
                };
                if (sessionStorage.getItem("userInvoiceInfo")) {
                    let userInvoiceInfo = JSON.parse(sessionStorage.getItem("userInvoiceInfo"));
                    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
                    userInvoiceInfo.invoicePrice = this.totalPrice;
                    userInvoiceInfo.userId = userInfo.user.id;
                    obj.userInvoiceInfo = userInvoiceInfo;
                }
                if (this.remark !== "") obj.remark = this.remark;
                const resp = await this.$apis.paymentServe.generate(obj);
                if (resp.resultCode === "200") {
                    this.payBatchId = resp.data.payBatchid;
                    if (resp.data.payStatus == 0) {
                        // 免费商品，不需要调支付接口，直接生成订单跳转订单列表或者详情
                        this.$router.push({ path: "/orders" });
                    } else {
                        this.$router.replace({
                            path: "/orderDetails",
                            query: {
                                id: resp.data.payBatchid,
                                isPrimaryOrder: true,
                                payType: this.radio,
                                createTime: resp.data.createTime,
                            },
                        });
                        // // 付费商品，根据支付方式唤起银联支付
                        // if (this.radio === "1") {
                        //   this.zhifubaoGetPay();
                        // } else {
                        //   this.weixinGetPay();
                        // }
                    }
                } else if (resp.resultDesc === "商品信息发生改变，请重新选择购买！！！") {
                    // 判断当前商品状态
                    Dialog.confirm({
                        message: "商品信息发生改变，请重新选择购买",
                    }).then(() => {
                        window.history.go(-1);
                    });
                } else {
                    this.hshow = true;
                }
                this.btnDisabled = false;
            } else {
                Toast("请填写地址");
            }
        },
        // 银联支付宝接口
        async zhifubaoGetPay() {
            const resp = await this.$apis.paymentServe.getPay({
                payBatchId: this.payBatchId,
                payType: "h5_ali",
            });
            if (resp.resultCode === "200") {
                location.href = resp.data;
                this.timer = setTimeout(() => {
                    this.btnDisabled = false;
                }, 3000);
            } else {
                // Dialog.confirm({
                //   message: "交易订单处理失败，请重新发起支付",
                // }).then(() => {
                //   // 跳转查看订单
                //   // window.history.go(-1);
                // });
                this.sshow = true;
                this.btnDisabled = false;
            }
        },
        // 银联微信接口
        async weixinGetPay() {
            const resp = await this.$apis.paymentServe.getPay({
                merAppId: this.$global.zhifu,
                payBatchId: this.payBatchId,
                payType: "h5_wx",
                sceneType: this.$global.isAndroid_ios() ? "AND_WAP" : "IOS_WAP",
            });
            if (resp.resultCode === "200") {
                location.href = resp.data;
                this.timer = setTimeout(() => {
                    this.btnDisabled = false;
                }, 3000);
            } else {
                Dialog.confirm({
                    message: "交易订单处理失败，请重新发起支付",
                }).then(() => {
                    // 跳转查看订单
                    // window.history.go(-1);
                });
                this.sshow = true;
                this.btnDisabled = false;
            }
        },
        // 收货地址
        async getByUserLists() {
            let data = JSON.parse(sessionStorage.getItem("userInfo"));
            const res = await this.$apis.addressServe.getByUserList({
                userId: data.user.id,
            });
            if (res.data.length !== 0) {
                this.Address = res.data[0];
                sessionStorage.setItem("Address", JSON.stringify(this.Address));
            }
        },
        // 没有收货地址点击跳转添加
        increaseAddress() {
            this.$router.push({ path: "/address", query: { isFrom: "confirm" } });
        },
        // 打开备注弹层
        openPopup(name) {
            this[`${name}Popup`] = this[name];
            this[`${name}PopupShow`] = true;
        },
        // 确认填写备注
        confirmRemark() {
            this.remark = this.remarkPopup;
            this.remarkPopupShow = false;
        },
        // 确保输入框不被软键盘遮挡 处理ios16问题
        handleElemInView(e) {
            window.scrollTo(0, window.innerHeight - 375);
        },
    },

    beforeRouteLeave(to, from, next) {
        if (to.name === "bookDetails" || to.name === "tobepaid" || to.name === "orders") {
            sessionStorage.removeItem("userInvoiceInfo");
            sessionStorage.removeItem("Address");
            //清除定时器
            clearInterval(this.timer);
            this.timer = null;
        }
        next();
    },
};
</script>

<style lang="scss" scoped>
.bookConfirmOrder {
    width: 100vw;
    min-height: 100vh;
    background: #f5f5f5;

    .content {
        margin: 12px;

        .content_address {
            padding: 12px;
            margin-bottom: 12px;
            background: #fff;
            border-radius: 8px;
            display: flex;
            height: 103px;

            .content_address_left {
                width: 320px;

                .address {
                    span {
                        font-size: 14px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #999999;
                        line-height: 20px;
                    }
                }

                h3 {
                    font-size: 15px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #333333;
                    line-height: 21px;
                    margin-top: 6px;
                }

                h4 {
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #333333;
                    line-height: 20px;
                    margin-top: 6px;
                }
            }

            .icon {
                padding-top: 27px;

                img {
                    width: 5px;
                    height: 9px;
                }
            }
        }

        .content_noaddress {
            margin-bottom: 15px;
        }

        .commodity_name {
            padding: 12px;
            margin-bottom: 12px;
            background: #fff;
            border-radius: 8px;
            height: 145px;

            .title {
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #333333;
                line-height: 20px;
            }

            .contents {
                display: flex;
                margin-top: 15px;

                .commodity_name_left {
                    width: 80px;
                    height: 80px;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                .commodity_name_right {
                    margin-left: 10px;

                    p {
                        width: 250px;
                        font-size: 15px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #333333;
                        line-height: 23px;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        overflow: hidden;
                    }

                    .introduction {
                        display: flex;
                        margin-top: 8px;
                        font-size: 13px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #999999;
                        line-height: 21px;

                        .details {
                            width: 220px;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }
                    }

                    .price {
                        margin-top: 8px;
                        font-size: 16px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #333333;
                        line-height: 17px;
                    }
                }
            }
        }

        .order-remark {
            margin-top: 12px;
            padding: 5px 0;
            width: 100%;
            background-color: #fff;
            border-radius: 8px;
            overflow: hidden;

            .cell-value {
                font-size: 14px;
                color: #333333;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

        .payment {
            margin-top: 12px;
            padding: 12px;
            background: #fff;
            border-radius: 8px;

            .title {
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #333333;
                line-height: 20px;
            }

            .option {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                height: 80px;

                ::v-deep.van-radio__icon--checked .van-icon {
                    background-color: #4a79f1;
                    border-color: #4a79f1;
                }

                .zhifubao {
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;

                    img {
                        width: 30px;
                        height: 30px;
                    }

                    .option_name {
                        font-size: 15px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #333333;
                        line-height: 21px;
                        margin-left: 15px;
                        width: 250px;
                    }

                    .img-icon {
                        width: 20px;
                        height: 20px;
                    }
                }

                .weixin {
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;

                    img {
                        width: 30px;
                        height: 30px;
                    }

                    .option_name {
                        font-size: 15px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #333333;
                        line-height: 21px;
                        margin-left: 15px;
                        width: 250px;
                    }

                    .img-icon {
                        width: 20px;
                        height: 20px;
                    }
                }
            }
        }
    }

    .popup-content {
        margin: 25px 25px 5px;

        .popup-input {
            margin-bottom: 55px;
            background-color: #f5f5f5;
            border-radius: 8px;
        }

        .popup-textarea {
            margin-bottom: 19px;
        }

        .popup-btn {
            width: 100%;
            height: 44px;
            background-color: #4a79f1;
            border-radius: 22px;
            font-size: 16px;
            color: #ffffff;
            line-height: 44px;
        }
    }

    .submit {
        width: 100%;
        position: fixed;
        bottom: 0px;
        height: 49px;
        background: #fff;
        display: flex;
        padding: 0px 0px 0px 15px;

        .money {
            font-size: 21px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ff3d3d;
            line-height: 17px;
            width: 190px;
            margin-top: 16px;
        }

        .obt {
            width: 160px;
            height: 44px;
            border-radius: 22px;
            margin-top: 3px;
            margin-right: 15px;
        }
    }
}
</style>
